export const INITIAL_LANG = "da-DK";
export const DEFAULT_NS = "translation";
